import {radioAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

import colors from '../foundations/colors'
import opacity from '../foundations/opacity'
import shadow from '../foundations/shadow'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(radioAnatomy.keys)

const baseStyle = definePartsStyle({
  container: {
    alignItems: 'flex-start',
    gap: spacing['5xs'],
  },
  label: {
    textColor: colors.text.secondary,
    marginInlineStart: 0,
    ...typography.textStyles.body.medium,
  },
  control: {
    border: '1px solid',
    borderColor: colors.icon.primary,
    position: 'relative',
    top: '2px',
    _hover: {
      borderColor: colors.icon['brand-hover'],
    },
    _disabled: {
      background: 'unset',
      borderColor: colors.icon.primary,
      opacity: opacity.disabled,
    },
    _checked: {
      borderColor: colors.icon.brand,
      background: colors.icon.brand,
      _hover: {
        background: colors.icon['brand-hover'],
        borderColor: colors.icon['brand-hover'],
      },
    },
    _invalid: {
      borderColor: colors.icon.primary,
      _checked: {
        borderColor: colors.icon.error,
        background: colors.icon.error,
      },
      _hover: {
        borderColor: colors.icon.error,
      },
    },
    _focus: {
      shadow: shadow.focus,
    },
  },
})

const radioTheme = defineMultiStyleConfig({
  baseStyle,
})

export default radioTheme
